if (!customElements.get("td-lp-combined-free-gift")) {
  class TdLpCombinedFreeGift extends HTMLElement {
    constructor() {
      super();
      // Get all free gift elements
      this.freeGiftElements = this.querySelectorAll('[data-free-gift-parent-id]');
    }

    connectedCallback() {
      // Listen for free gift update events from the product selector
      document.addEventListener('free-gift-update', (e) => this.handleFreeGiftUpdate(e));
    }

    handleFreeGiftUpdate(event) {
      const { productId, purchaseType } = event.detail;
      
      // Show/hide free gifts based on product ID match AND purchase type
      this.freeGiftElements.forEach(freeGift => {
        const freeGiftProductId = freeGift.getAttribute('data-free-gift-parent-id');
        
        // Only show free gift if product matches AND subscription is selected
        if (freeGiftProductId === productId && purchaseType === 'subscription') {
          freeGift.classList.add('td-gift-active');
        } else {
          freeGift.classList.remove('td-gift-active');
        }
      });
    }
  }

  customElements.define("td-lp-combined-free-gift", TdLpCombinedFreeGift);
}
